import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Box, Container, Pagination, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { DashboardLayout } from "../../components/dashboard-layout";
import { theme } from "../../theme";

const localDate = (date) => {
    const offset = date.getTimezoneOffset();
    return new Date(date.getTime() - offset * 60000).toISOString().slice(0, 10);
};

const displayDate = (value) => {
    if (!value) return "-";
    return new Date(value).toLocaleString("vi-VN", { hour12: false });
};

function ApprovalHistory() {
    const [startDate, setStartDate] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() - 7);
        return localDate(date);
    });
    const [endDate, setEndDate] = useState(() => localDate(new Date()));
    const [player, setPlayer] = useState("");
    const [approver, setApprover] = useState("");
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const pageSize = 50;

    const loadHistory = () => {
        const params = `page=1&limit=200&startDate=${startDate}&endDate=${endDate}&status=All`;
        Promise.all([
            axios.get(`${process.env.REACT_APP_API_URL}/payment/nap?${params}`),
            axios.get(`${process.env.REACT_APP_API_URL}/payment/rut?${params}`)
        ]).then(([deposit, withdraw]) => {
            const deposits = (deposit.data?.data || []).map((item) => ({ ...item, approvalType: "Nạp điểm" }));
            const withdrawals = (withdraw.data?.data || []).map((item) => ({ ...item, approvalType: "Rút điểm" }));
            setRows([...deposits, ...withdrawals]
                .filter((item) => ["Success", "Accept"].includes(item.status_payment))
                .sort((a, b) => new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt)));
            setPage(1);
        }).catch(() => setRows([]));
    };

    useEffect(() => {
        loadHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredRows = useMemo(() => rows.filter((item) => {
        const username = item?.user?.username || "";
        const admin = item?.adminUpdated || item?.approvedBy || "";
        return username.toLowerCase().includes(player.toLowerCase()) && admin.toLowerCase().includes(approver.toLowerCase());
    }), [rows, player, approver]);

    const pageRows = filteredRows.slice((page - 1) * pageSize, page * pageSize);
    const pages = Math.max(1, Math.ceil(filteredRows.length / pageSize));

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" className="happy-approval-page">
                    <Container maxWidth={false} className="happy-approval-container">
                        <div className="happy-approval-header">
                            <button className="ax-guide-button">Hướng dẫn <span>?</span></button>
                        </div>
                        <div className="happy-approval-filter">
                            <div className="ax-filter-item">
                                <label>Khoảng thời gian</label>
                                <div className="happy-approval-range">
                                    <input type="date" value={startDate} onChange={(event) => setStartDate(event.target.value)} />
                                    <span>→</span>
                                    <input type="date" value={endDate} onChange={(event) => setEndDate(event.target.value)} />
                                </div>
                            </div>
                            <div className="ax-filter-item">
                                <label>Tên người chơi</label>
                                <input placeholder="Tên người chơi" value={player} onChange={(event) => setPlayer(event.target.value)} />
                            </div>
                            <div className="ax-filter-item">
                                <label>Người duyệt</label>
                                <input placeholder="Người duyệt" value={approver} onChange={(event) => setApprover(event.target.value)} />
                            </div>
                            <div className="happy-finance-actions">
                                <button className="ax-btn-search-red" onClick={loadHistory}>Tìm kiếm</button>
                            </div>
                        </div>
                        <div className="ax-table-wrapper happy-finance-table happy-approval-table">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tên người chơi</TableCell>
                                        <TableCell>Người duyệt</TableCell>
                                        <TableCell>Loại</TableCell>
                                        <TableCell>Số điểm</TableCell>
                                        <TableCell>Ghi chú</TableCell>
                                        <TableCell>Ngày duyệt</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {pageRows.length ? pageRows.map((item) => (
                                        <TableRow key={`${item.approvalType}-${item._id}`}>
                                            <TableCell>{item?.user?.username || "-"}</TableCell>
                                            <TableCell>{item?.adminUpdated || item?.approvedBy || "-"}</TableCell>
                                            <TableCell>{item.approvalType}</TableCell>
                                            <TableCell>{Math.floor(Number(item?.money || 0) / 1000).toLocaleString("vi-VN")}</TableCell>
                                            <TableCell>{item?.note || (["Deny","Cancelled","Cancel","Failed"].includes(item?.status_payment) ? "Thất bại" : "Thành công")}</TableCell>
                                            <TableCell>{displayDate(item?.updatedAt || item?.createdAt)}</TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow><TableCell colSpan={6} align="center">Không có dữ liệu</TableCell></TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <Box className="happy-approval-pagination">
                            <Pagination page={page} count={pages} onChange={(_, value) => setPage(value)} />
                        </Box>
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default ApprovalHistory;
